/**
 * Data attributes the drag engine toggles imperatively on the sheet's DOM nodes, outside of React renders.
 * The matching styles live alongside the Tailwind classes on each part in `Sheet.tsx`.
 */
export const DRAGGING_ATTRIBUTE = 'data-sheet-dragging';
export const TRANSITION_ATTRIBUTE = 'data-sheet-transition';
export const FULL_HEIGHT_ATTRIBUTE = 'data-sheet-full-height';
export const CONTENT_HEIGHT_ATTRIBUTE = 'data-content-height';
export const CLOSING_CLASS = 'is-closing';

/** Applies or removes a boolean sheet state attribute. */
export const setSheetStateAttribute = (
    element: HTMLElement | null | undefined,
    attribute: string,
    isActive: boolean,
): void => {
    if (!element) return;

    if (isActive) {
        element.setAttribute(attribute, 'true');
        return;
    }

    element.removeAttribute(attribute);
};

/** Added to `<html>` while a drag is in progress. The consuming app owns this class's styles. */
export const PREVENT_OVERSCROLL_CLASS = 'prevent-overscroll';

/** Marks a subtree whose own scrolling takes priority over dragging the sheet. */
export const SCROLLABLE_ATTRIBUTE = 'data-scrollable';

/** Marks a subtree that must never start a sheet drag. */
export const IGNORE_DRAGS_ATTRIBUTE = 'data-sheet-ignore-drags';
